/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type MessageBanner_viewer = {|
  +messages?: ?$ReadOnlyArray<?{|
    +items: ?$ReadOnlyArray<?{|
      +impressionCap: ?number;
      +note: ?{|
        +serviceId: ?string;
        +content: ?{|
          +title: ?string;
          +message: ?string;
          +cta: ?{|
            +text: ?string;
            +url: ?string;
          |};
        |};
        +anchors: ?$ReadOnlyArray<?{|
          +serviceId?: ?string;
          +content?: ?{|
            +title: ?string;
            +message: ?string;
            +cta: ?{|
              +text: ?string;
              +url: ?string;
            |};
          |};
        |}>;
      |};
    |}>;
  |}>;
  +allTransactions?: ?{|
    +totalResults: ?number;
  |};
  +initiatedTransactions?: ?{|
    +totalResults: ?number;
  |};
  +submittedTransactions?: ?{|
    +totalResults: ?number;
  |};
  +confirmedTransactions?: ?{|
    +totalResults: ?number;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "hasUserType",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "setId",
      "type": "String!",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "userType",
      "type": "String!",
      "defaultValue": ""
    },
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": "[String]"
    },
    {
      "kind": "RootArgument",
      "name": "fetchMarketingMessagesTransactions",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MessageBanner_viewer",
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchMarketingMessagesTransactions",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "allTransactions",
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userIds",
              "type": "[String]"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 0,
              "type": "Int"
            }
          ],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": "initiatedTransactions",
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userIds",
              "type": "[String]"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 0,
              "type": "Int"
            },
            {
              "kind": "Literal",
              "name": "viewName",
              "value": "buyerTracking.initiated",
              "type": "String"
            }
          ],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": "submittedTransactions",
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userIds",
              "type": "[String]"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 0,
              "type": "Int"
            },
            {
              "kind": "Literal",
              "name": "viewName",
              "value": "buyerTracking.submitted",
              "type": "String"
            }
          ],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": "confirmedTransactions",
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userIds",
              "type": "[String]"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 0,
              "type": "Int"
            },
            {
              "kind": "Literal",
              "name": "sort",
              "value": "createdDate asc",
              "type": "String"
            },
            {
              "kind": "Literal",
              "name": "viewName",
              "value": "buyerTracking.confirmed",
              "type": "String"
            }
          ],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserType",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "messages",
          "args": [
            {
              "kind": "Variable",
              "name": "setId",
              "variableName": "setId",
              "type": "String"
            },
            {
              "kind": "Variable",
              "name": "userType",
              "variableName": "userType",
              "type": "String!"
            }
          ],
          "concreteType": "MessageSetModule",
          "name": "messageSet",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "MessageSetItem",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "impressionCap",
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "MarketingMessage",
                  "name": "note",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "serviceId",
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "args": null,
                      "concreteType": "MarketingMessageContent",
                      "name": "content",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "title",
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "message",
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "args": null,
                          "concreteType": "MarketingMessageCta",
                          "name": "cta",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "text",
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "url",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "args": null,
                      "concreteType": "MarketingMessage",
                      "name": "anchors",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "type": "MarketingMessage",
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "serviceId",
                              "storageKey": null
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "args": null,
                              "concreteType": "MarketingMessageContent",
                              "name": "content",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "args": null,
                                  "name": "title",
                                  "storageKey": null
                                },
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "args": null,
                                  "name": "message",
                                  "storageKey": null
                                },
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "MarketingMessageCta",
                                  "name": "cta",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "ScalarField",
                                      "alias": null,
                                      "args": null,
                                      "name": "text",
                                      "storageKey": null
                                    },
                                    {
                                      "kind": "ScalarField",
                                      "alias": null,
                                      "args": null,
                                      "name": "url",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ]
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/MessageBanner/__generated__/MessageBanner_viewer.graphql.js